import type { Volume } from '@/entities/volume';
import request from '@/shared/api/request';

export const getVolume = (uuid: string): Promise<{ volume: Volume }> =>
  request({
    url: `/volumes/${uuid}/`,
  });
